import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemesService } from 'src/app/services/commonService/themes.service';
import { ErrorService } from 'src/app/services/errorService/error.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';

@Component({
  selector: 'app-opps-error-state',
  templateUrl: './opps-error-state.component.html',
  styleUrls: ['./opps-error-state.component.scss'],
  imports: [MatButton, RouterLink, MatIcon]
})
export class OppsErrorStateComponent implements OnInit {
    content: any;
    signUpContent: any;
  errorMessage: string = ''
  errorCode: number = 404;
  redirectUrl: string = ''
  constructor(private readonly bookingContentService: BookingContentService, private readonly signUpContentService: SignUpContentServiceService, private errorService: ErrorService, private route: ActivatedRoute, private themeService: ThemesService) {
    this.themeService.setTheme('passengererrorpage');
  }



  ngOnInit(): void {
    this.errorService.getErrorMessage().subscribe((message) => {
      if (message) {
        this.errorMessage = message;
      }
    });

    this.errorService.getErrorCode().subscribe((code) => {
      if (code) {
        this.errorCode = code;
      }
    });

    this.errorService.getRedirectURL().subscribe((data) => {
      if (data) {
        this.redirectUrl = data;
      }
    });
      this.bookingContentService.content$.subscribe((res: any) => { this.content = res; });
      this.signUpContentService.content$.subscribe((res: any) => { this.signUpContent = res; });
  }
  tryAgain() {

    window.history.back()
  }
}
